module.exports = __webpack_public_path__ + "img/logo-cercle.f13c8ddf.jpg";